import { PropertyModel } from 'common/data/property/model';
import { PropertyImageModel } from 'common/data/property-image/model';
import { ImageGalleryItemInterface } from 'common/module/image-gallery/item.interface';
import { ImageGalleryItemTypeEnum } from 'common/module/image-gallery/item-type.enum';

import { galleryItemsMapper } from './items-mapper';

export const galleryGetGalleryScrollItems = (
  property: PropertyModel,
  size: keyof PropertyImageModel['links'] = 'small'
): ImageGalleryItemInterface[] => {
  let items: ImageGalleryItemInterface[] = [];

  if (property.property_images?.length) {
    const images = property.property_images;

    items =
      images.length > 3 && property.meta.contact_options.list.whatsapp
        ? [
            ...galleryItemsMapper(images.slice(0, 3), size, property.id),
            {
              type: ImageGalleryItemTypeEnum.NUDGE,
              sourceUrl: images[3].links[size],
              thumbUrl: images[3].links.thumb,
              propertyId: property.id,
            },
            ...galleryItemsMapper(images.slice(3), size, property.id),
          ]
        : galleryItemsMapper(images, size, property.id);
  }

  return items;
};
